/**
 * @author Daniel Aguirre
 * @file constants.js
 * @description Dashboard Staff Constants
 */

export const CLINICS_ENTITY_ID = 2;
export const INSURERS_ENTITY_ID = 3;

// Generic actions
export const GET_RECOMMENDED_BY_SCHEDULING =
  'Patient/GET_RECOMMENDED_BY_SCHEDULING';
export const GET_RECOMMENDED_BY_SCHEDULING_LIST =
  'Patient/GET_RECOMMENDED_BY_SCHEDULING_LIST';

export const GET_ANTIBODY_ANTI_HBS = 'Patient/GET_ANTIBODY_ANTI_HBS';
export const GET_ANTIBODY_ANTI_HBS_LIST = 'Patient/GET_ANTIBODY_ANTI_HBS_LIST';
export const GET_ANTIBODY_ANTI_HBS_LIST_PLUS =
  'Patient/GET_ANTIBODY_ANTI_HBS_LIST_PLUS';

export const GET_INDI_BLOOD_PRESSURE_MONITORING =
  'Patient/GET_INDI_BLOOD_PRESSURE_MONITORING';
export const GET_INDI_BLOOD_PRESSURE_MONITORING_LIST =
  'Patient/GET_INDI_BLOOD_PRESSURE_MONITORING_LIST';
export const GET_INDI_BLOOD_PRESSURE_MONITORING_LIST_PLUS =
  'Patient/GET_INDI_BLOOD_PRESSURE_MONITORING_LIST_PLUS';

export const GET_INDI_GLUCOSE_MONITORING =
  'Patient/GET_INDI_GLUCOSE_MONITORING';
export const GET_INDI_GLUCOSE_MONITORING_LIST =
  'Patient/GET_INDI_GLUCOSE_MONITORING_LIST';
export const GET_INDI_GLUCOSE_MONITORING_LIST_PLUS =
  'Patient/GET_INDI_GLUCOSE_MONITORING_LIST_PLUS';

export const GET_ALBUMINURIA_PROGRESS = 'Patient/GET_ALBUMINURIA_PROGRESS';
export const GET_ALBUMINURIA_PROGRESS_LIST =
  'Patient/GET_ALBUMINURIA_PROGRESS_LIST';
export const GET_ALBUMINURIA_PROGRESS_LIST_PLUS =
  'Patient/GET_ALBUMINURIA_PROGRESS_LIST_PLUS';

export const GET_ALBUMINURIA_F13 = 'Patient/GET_ALBUMINURIA_F13';
export const GET_ALBUMINURIA_F13_LIST = 'Patient/GET_ALBUMINURIA_F13_LIST';
export const GET_ALBUMINURIA_F13_LIST_PLUS =
  'Patient/GET_ALBUMINURIA_F13_LIST_PLUS';

export const GET_TFG_DETERIORATION = 'Patient/GET_TFG_DETERIORATION';
export const GET_TFG_DETERIORATION_LIST = 'Patient/GET_TFG_DETERIORATION_LIST';
export const GET_TFG_DETERIORATION_LIST_PLUS =
  'Patient/GET_TFG_DETERIORATION_LIST_PLUS';

export const GET_NUTRITIONAL_INDICATOR = 'Patient/GET_NUTRITIONAL_INDICATOR';
export const GET_NUTRITIONAL_INDICATOR_LIST =
  'Patient/GET_NUTRITIONAL_INDICATOR_LIST';
export const GET_NUTRITIONAL_INDICATOR_LIST_PLUS =
  'Patient/GET_NUTRITIONAL_INDICATOR_LIST_PLUS';

export const GET_ALBUMINA = 'Patient/GET_ALBUMINA';
export const GET_ALBUMINA_LIST = 'Patient/GET_ALBUMINA_LIST';
export const GET_ALBUMINA_LIST_PLUS = 'Patient/GET_ALBUMINA_LIST_PLUS';

export const GET_HEMOGLOBIN = 'Patient/GET_HEMOGLOBIN';
export const GET_HEMOGLOBIN_LIST = 'Patient/GET_HEMOGLOBIN_LIST';
export const GET_HEMOGLOBIN_LIST_PLUS = 'Patient/GET_HEMOGLOBIN_LIST_PLUS';

export const GET_POTASSIUM = 'Patient/GET_POTASSIUM';
export const GET_POTASSIUM_LIST = 'Patient/GET_POTASSIUM_LIST';
export const GET_POTASSIUM_LIST_PLUS = 'Patient/GET_POTASSIUM_LIST_PLUS';

export const GET_PHOSPHORUS = 'Patient/GET_PHOSPHORUS';
export const GET_PHOSPHORUS_LIST = 'Patient/GET_PHOSPHORUS_LIST';
export const GET_PHOSPHORUS_LIST_PLUS = 'Patient/GET_PHOSPHORUS_LIST_PLUS';

export const GET_MISSED_APPOINTMENTS_BY_STAGE =
  'Patient/GET_MISSED_APPOINTMENTS_BY_STAGE';
export const GET_MISSED_APPOINTMENTS_BY_STAGE_LIST =
  'Patient/GET_MISSED_APPOINTMENTS_BY_STAGE_LIST';
export const GET_MISSED_APPOINTMENTS_BY_STAGE_LIST_PLUS =
  'Patient/GET_MISSED_APPOINTMENTS_BY_STAGE_LIST_PLUS';

export const GET_PROTEINURIA = 'Patient/GET_PROTEINURIA';
export const GET_PROTEINURIA_LIST_PLUS = 'Patient/GET_PROTEINURIA_LIST_PLUS';
export const GET_PROTEINURIA_DETAIL = 'Patient/GET_PROTEINURIA_DETAIL';
export const GET_METABOLIC_CONTROL_DIABETES =
  'Patient/GET_METABOLIC_CONTROL_DIABETES';
export const GET_METABOLIC_CONTROL_DIABETES_LIST =
  'Patient/GET_METABOLIC_CONTROL_DIABETES_LIST';
export const GET_METABOLIC_CONTROL_DIABETES_LIST_PLUS =
  'Patient/GET_METABOLIC_CONTROL_DIABETES_LIST_PLUS';

export const GET_PTH_INDICATOR = 'Patient/GET_PTH_INDICATOR';
export const GET_PTH_INDICATOR_LIST = 'Patient/GET_PTH_INDICATOR_LIST';
export const GET_PTH_INDICATOR_LIST_PLUS =
  'Patient/GET_PTH_INDICATOR_LIST_PLUS';

export const GET_SEROSTATUS_HEPATITIS_B = 'Patient/GET_SEROSTATUS_HEPATITIS_B';
export const GET_SEROSTATUS_HEPATITIS_B_LIST =
  'Patient/GET_SEROSTATUS_HEPATITIS_B_LIST';

export const GET_RISK = 'Patient/GET_RISK';
export const GET_RISK_LIST = 'Patient/GET_RISK_LIST';
export const GET_RISK_LIST_PLUS = 'Patient/GET_RISK_LIST_PLUS';

export const GET_BLOOD_PRESSURE = 'Patient/GET_BLOOD_PRESSURE';
export const GET_BLOOD_PRESSURE_LIST = 'Patient/GET_BLOOD_PRESSURE_LIST';
export const GET_BLOOD_PRESSURE_LIST_PLUS =
  'Patient/GET_BLOOD_PRESSURE_LIST_PLUS';
export const GET_VACCINE_SCHEDULING = 'Patient/GET_VACCINE_SCHEDULING';
export const GET_VACCINE_SCHEDULING_LIST =
  'Patient/GET_VACCINE_SCHEDULING_LIST';
export const GET_VACCINE_SCHEDULING_LIST_PLUS =
  'Patient/GET_VACCINE_SCHEDULING_LIST_PLUS';

export const GET_POST_VACCINE_ANTI_HBS = 'Patient/GET_POST_VACCINE_ANTI_HBS';
export const GET_POST_VACCINE_ANTI_HBS_LIST =
  'Patient/GET_POST_VACCINE_ANTI_HBS_LIST';

export const GET_RISK_REGISTER = 'Patient/GET_RISK_REGISTER';
export const GET_RISK_REGISTER_LIST = 'Patient/GET_RISK_REGISTER_LIST';
export const GET_RISK_REGISTER_LIST_PLUS =
  'Patient/GET_RISK_REGISTER_LIST_PLUS';

export const GET_LOSS_HEPATITIS_IMMUNITY =
  'Patient/GET_LOSS_HEPATITIS_IMMUNITY';
export const GET_LOSS_HEPATITIS_IMMUNITY_LIST =
  'Patient/GET_LOSS_HEPATITIS_IMMUNITY_LIST';
export const GET_LOSS_HEPATITIS_IMMUNITY_LIST_PLUS =
  'Patient/GET_LOSS_HEPATITIS_IMMUNITY_LIST_PLUS';

export const GET_CORRELATION_RISK_RATE_PROGRESSION =
  'Patient/GET_CORRELATION_RISK_RATE_PROGRESSION';
export const GET_CORRELATION_RISK_RATE_PROGRESSION_LIST =
  'Patient/GET_CORRELATION_RISK_RATE_PROGRESSION_LIST';
export const GET_CORRELATION_RISK_RATE_PROGRESSION_LIST_PLUS =
  'Patient/GET_CORRELATION_RISK_RATE_PROGRESSION_LIST_PLUS';

export const GET_TREATMENT_OPTIONS = 'Patient/GET_TREATMENT_OPTIONS';
export const GET_TREATMENT_OPTIONS_LIST = 'Patient/GET_TREATMENT_OPTIONS_LIST';
export const GET_TREATMENT_OPTIONS_LIST_PLUS =
  'Patient/GET_TREATMENT_OPTIONS_LIST_PLUS';

export const GET_PSYCHOSOCIAL_RISK = 'Patient/GET_PSYCHOSOCIAL_RISK';
export const GET_PSYCHOSOCIAL_RISK_LIST = 'Patient/GET_PSYCHOSOCIAL_RISK_LIST';
export const GET_PSYCHOSOCIAL_RISK_LIST_PLUS =
  'Patient/GET_PSYCHOSOCIAL_RISK_LIST_PLUS';

export const GET_PSYCHOSOCIAL_RISK_PSYCHOLOGY =
  'Patient/GET_PSYCHOSOCIAL_RISK_PSYCHOLOGY';
export const GET_PSYCHOSOCIAL_RISK_PSYCHOLOGY_LIST =
  'Patient/GET_PSYCHOSOCIAL_RISK_PSYCHOLOGY_LIST';
export const GET_PSYCHOSOCIAL_RISK_PSYCHOLOGY_LIST_PLUS =
  'Patient/GET_PSYCHOSOCIAL_RISK_PSYCHOLOGY_LIST_PLUS';

export const GET_ACCESS = 'Patient/GET_ACCESS';
export const GET_ACCESS_LIST = 'Patient/GET_ACCESS_LIST';
export const GET_ACCESS_LIST_PLUS = 'Patient/GET_ACCESS_LIST_PLUS';

export const GET_SCHEDULING_ALERT = 'Patient/GET_SCHEDULING_ALERT';
export const GET_SCHEDULING_ALERT_LIST = 'Patient/GET_SCHEDULING_ALERT_LIST';
export const GET_SCHEDULING_ALERT_LIST_PLUS =
  'Patient/GET_SCHEDULING_ALERT_LIST_PLUS';

export const GET_PROTEIN_ENERGETIC_WEAR = 'Patient/GET_PROTEIN_ENERGETIC_WEAR';
export const GET_PROTEIN_ENERGETIC_WEAR_LIST =
  'Patient/GET_PROTEIN_ENERGETIC_WEAR_LIST';
export const GET_PROTEIN_ENERGETIC_WEAR_LIST_PLUS =
  'Patient/GET_PROTEIN_ENERGETIC_WEAR_LIST_PLUS';

export const GET_GENERAL_SOCIAL_T_SOCIAL_RISK =
  'Patient/GET_GENERAL_SOCIAL_T_SOCIAL_RISK';
export const GET_GENERAL_SOCIAL_T_SOCIAL_RISK_LIST =
  'Patient/GET_GENERAL_SOCIAL_T_SOCIAL_RISK_LIST';
export const GET_GENERAL_SOCIAL_T_SOCIAL_RISK_LIST_PLUS =
  'Patient/GET_GENERAL_SOCIAL_T_SOCIAL_RISK_LIST_PLUS';

export const GET_NURSING_EDUCATION = 'Patient/GET_NURSING_EDUCATION';
export const GET_NURSING_EDUCATION_LIST = 'Patient/GET_NURSING_EDUCATION_LIST';
export const GET_NURSING_EDUCATION_LIST_PLUS =
  'Patient/GET_NURSING_EDUCATION_LIST_PLUS';

export const GET_ASSESMENT_IN_PSYCHOLOGY =
  'Patient/GET_ASSESMENT_IN_PSYCHOLOGY';
export const GET_ASSESMENT_IN_PSYCHOLOGY_LIST =
  'Patient/GET_ASSESMENT_IN_PSYCHOLOGY_LIST';

export const GET_DISSENT_WITHOUT_PSYCHOLOGY_ASSESSMENT =
  'Patient/GET_DISSENT_WITHOUT_PSYCHOLOGY_ASSESSMENT';
export const GET_DISSENT_WITHOUT_PSYCHOLOGY_ASSESSMENT_LIST =
  'Patient/GET_DISSENT_WITHOUT_PSYCHOLOGY_ASSESSMENT_LIST';
export const GET_DISSENT_WITHOUT_PSYCHOLOGY_ASSESSMENT_LIST_PLUS =
  'Patient/GET_DISSENT_WITHOUT_PSYCHOLOGY_ASSESSMENT_LIST_PLUS';
export const GET_PATIENT_EVENTS = 'Patient/GET_PATIENT_EVENTS';
export const GET_PATIENT_EVENTS_LIST = 'Patient/GET_PATIENT_EVENTS_LIST';
export const GET_PATIENT_EVENTS_LIST_PLUS =
  'Patient/GET_PATIENT_EVENTS_LIST_PLUS';

export const GET_PERIODICITY_ATTENTION = 'Patient/GET_PERIODICITY_ATTENTION';
export const GET_PERIODICITY_ATTENTION_LIST =
  'Patient/GET_PERIODICITY_ATTENTION_LIST';

export const GET_CONSTRUCTION_ACCESS_ASSESSMENT =
  'Patient/GET_CONSTRUCTION_ACCESS_ASSESSMENT';
export const GET_CONSTRUCTION_ACCESS_ASSESSMENT_LIST =
  'Patient/GET_CONSTRUCTION_ACCESS_ASSESSMENT_LIST';
export const GET_CONSTRUCTION_ACCESS_ASSESSMENT_LIST_PLUS =
  'Patient/GET_CONSTRUCTION_ACCESS_ASSESSMENT_LIST_PLUS';

export const GET_GENERAL_SOCIAL_RISK_REGISTER =
  'Patient/GET_GENERAL_SOCIAL_RISK_REGISTER';
export const GET_GENERAL_SOCIAL_RISK_REGISTER_LIST =
  'Patient/GET_GENERAL_SOCIAL_RISK_REGISTER_LIST';
export const GET_GENERAL_SOCIAL_RISK_REGISTER_LIST_PLUS =
  'Patient/GET_GENERAL_SOCIAL_RISK_REGISTER_LIST_PLUS';

export const GET_FOLLOW_UP_ABSENTEEISM_ADHERENCE =
  'Patient/GET_FOLLOW_UP_ABSENTEEISM_ADHERENCE';
export const GET_FOLLOW_UP_ABSENTEEISM_ADHERENCE_LIST =
  'Patient/GET_FOLLOW_UP_ABSENTEEISM_ADHERENCE_LIST';
export const GET_FOLLOW_UP_ABSENTEEISM_ADHERENCE_LIST_PLUS =
  'Patient/GET_FOLLOW_UP_ABSENTEEISM_ADHERENCE_LIST_PLUS';

export const GET_ADMON_CODES_BY_ENTITY = 'Patient/GET_ADMON_CODES_BY_ENTITY';
export const GET_LAST_UPDATE = 'Patient/GET_LAST_UPDATE';
